<div class="auth-layout relative">
  <router-outlet></router-outlet>



  <!-- <div
  class="absolute w-[350px] h-[350px] rounded-full bg-[var(--secondary-color)] opacity-50    top-[130px] left-[400px] "
  style="border-radius: 30% 70% 70% 30% / 30% 32% 68% 70% ; z-index: -1;"></div> -->
</div>
